import { Skeleton } from '@/components/ui/skeleton'

export function SessionSplash() {
  return (
    <div className="flex h-full items-center justify-center bg-background p-6">
      <Skeleton className="h-40 w-full max-w-sm rounded-md" />
    </div>
  )
}
